import classplusLogo from "../../assets/Images/classplus-logo.png";
import messageEdit from "../../assets/Images/message-edit.svg";
import playCircle from "../../assets/Images/play-cricle.svg";
import announce from "../../assets/Images/Announce.svg";
import "./headings.css";
import { useState, useEffect } from "react";
const Headings = ({
  userInputs,
  isNumberSubmitted,
  coachingName,
  showRadarScreen,
}) => {
  const [headingText, setHeadingText] = useState("Teacherpreneur")
  const headingTexts = ["Teacherpreneur", "Solopreneur", "Videopreneur", "Contentpreneur"];

  useEffect(() => {
    let index = 0
    const interval = setInterval(() => {
      if (index < headingTexts.length - 1) {
        setHeadingText(headingTexts[index + 1]);
        index++
      } else {
        index = 0
        setHeadingText(headingTexts[index]);
      }
    }, 2000)

    return (() => {
      clearInterval(interval);
    })

  }, [])
  return (
    <div className={userInputs[Object.keys(userInputs)[0]] ? `heading` : ""}>
      <img width={150} alt="classplus-logo" src={classplusLogo} />

      <h3 className="text-2xl mt-6 text-colorHeading font-semibold">
        {isNumberSubmitted ? (
          <>
            {showRadarScreen ? (
              `These are the top 3 ${
                userInputs["youtuber-name"]  || 
                userInputs["online-course-name"]
                  ? "content creators in your category"
                  : "educators in your region"
              }`
            ) : (
              <>
                <span className="border-b-4  border-colorWhite">Hi</span>,{" "}
                {coachingName}
              </>
            )}
          </>
        ) : (
          <>
            {/* <span className="border-b-4  border-colorWhite">Create</span> your
            online <br /> presence with Classplus */}
            Are you ready to be a <br />
            <span className="text-colorWhite border-b-2 border-colorHeading ">
              {headingText}?
            </span>
             {/* <span className="mb-4">
              <span className="js-nametag text-colorWhite border-b-2 border-colorHeading">Teacherpreneur</span>
              <span className="js-nametag text-colorWhite border-b-2 border-colorHeading">Solopreneur</span>
              <span className="js-nametag text-colorWhite border-b-2 border-colorHeading">Videopreneur</span>
            <span className="js-nametag text-colorWhite border-b-2 border-colorHeading">Contentpreneur</span> 
            </span>  */}

          </>
        )}
      </h3>
      {!isNumberSubmitted && (
        <>
         <p className={`mt-12 mb-6 ${userInputs["name"] ? "hideInfo" : ""}`}>
          <b>Kickstart Your Growth Journey</b>
        </p>

        <div className={`mt-6 mb-6 ${userInputs["name"] ? "hideInfo" : ""}`}>
            <span className="textStyleMob"><img src={messageEdit} className="imgStyleMob"/> Live Classes</span>
            <span className="textStyleMob"><img src={playCircle} className="imgStyleMob"/> Sell Courses</span>
            <span className="textStyleMob"><img src={announce} className="imgStyleMob"/> Marketing Assistance</span>
        </div>
        </>
      )}

      {isNumberSubmitted && (
        <p>
          {showRadarScreen ? (
            <>{ }</>
          ) : (
            <>We have something special in store for you</>
          )}
        </p>
      )}
    </div>
  );
};

export default Headings;
